import {
  ComponentIndex,
  ComponentNames,
  ComponentNamesCount,
  EntitiesEngine,
  Entity,
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IconEnumeratorComponent,
  IconModelComponent,
  IconsSceneObjectComponent,
  IGameStateMachineProvider,
  IReelsConfigProvider,
  MultiSceneReelsEngineV2,
  RegularSpinsSoundModelComponent,
  T_IconEnumeratorComponent,
  T_IconModelComponent,
  T_IconsSceneObjectComponent,
  T_IReelsConfigProvider,
  T_RegularSpinsSoundModelComponent,
} from '@cgs/machines';
import { NodeUtils } from '@cgs/shared';
import { Container, SceneObject } from '@cgs/wge';

export class CorsicaReelsEngine extends MultiSceneReelsEngineV2 {
  protected _iconNodeIndex: ComponentIndex;

  constructor(
    container: Container,
    useSounds: boolean = true,
    animatedIcons: number[],
    animName: string
  ) {
    const entityEngine = new EntitiesEngine(ComponentNamesCount);

    const iconsSceneObject = container.resolve<IconsSceneObjectComponent>(
      T_IconsSceneObjectComponent
    ).iconsRender;
    const animIconsSceneObject = container.resolve<IconsSceneObjectComponent>(
      T_IconsSceneObjectComponent
    ).animIconsRender;
    const iconModel = container.resolve<IconModelComponent>(T_IconModelComponent).iconModel;
    const enumerator =
      container.resolve<IconEnumeratorComponent>(T_IconEnumeratorComponent).iconsEnumerator;
    const reelsConfig = container.resolve<IReelsConfigProvider>(T_IReelsConfigProvider).reelsConfig;
    const gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    const reelsSoundModel = container.resolve<RegularSpinsSoundModelComponent>(
      T_RegularSpinsSoundModelComponent
    ).regularSpinSoundModel;

    super(
      container,
      entityEngine,
      iconsSceneObject,
      animIconsSceneObject,
      iconModel,
      enumerator,
      reelsConfig,
      gameStateMachine,
      reelsSoundModel,
      useSounds,
      animatedIcons,
      animName
    );

    this._iconNodeIndex = entityEngine.getComponentIndex(ComponentNames.IconNode);
  }

  startAnimation(entity: Entity, animationName: string): void {
    if (entity.hasComponent(this._iconNodeIndex)) {
      this.commandSystem.startAnimationInSingleIcon(entity, animationName);
      const so = entity.get<SceneObject>(this._iconNodeIndex);
      NodeUtils.removeMask(so);
      so.stateMachine!.switchToState(animationName);
    } else {
      this.commandSystem.startAnimation(entity, animationName);
    }
  }

  stopAnimation(entity: Entity, animationName: string): void {
    if (entity.hasComponent(this._iconNodeIndex)) {
      this.commandSystem.stopAnimationInSingleIcon(entity, animationName);
      const so = entity.get<SceneObject>(this._iconNodeIndex);
      NodeUtils.addMask(so);
      so.stateMachine!.switchToState('default');
    } else {
      this.commandSystem.stopAnimation(entity, animationName);
    }
  }
}
